import React, { useState } from 'react';
import { ChevronDown, Plus } from 'lucide-react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from 'components/ui/collapsible';
import { Icon, IconName } from '../menu-icon/menu-icon';
import { useTheme } from 'components/core/theme-provider';
// import { useSidebar } from 'components/ui/sidebar';

interface SidebarSectionProps {
    title: string;
    icon?: IconName;
    children: React.ReactNode;
    onAddClick?: (e: React.MouseEvent) => void;
    defaultOpen?: boolean;
}

export function SidebarCollapsibleSection({
    title,
    icon,
    children,
    onAddClick,
    defaultOpen = true,
}: SidebarSectionProps) {
    const [isOpen, setIsOpen] = useState(defaultOpen);
    const { theme } = useTheme();
    // const { open: isSidebarOpen } = useSidebar();

    // If sidebar is collapsed (icon mode), we might want to change behavior.
    // Generally, sections might stay 'open' but rendering changes, or they might be standard.
    // Based on "redesign", we assume standard behavior first.

    return (
        <Collapsible open={isOpen} onOpenChange={setIsOpen} className="group/section w-full">
            <div className="flex items-center justify-between gap-3 px-3 py-2 w-full group-data-[collapsible=icon]:justify-center">
                <CollapsibleTrigger asChild>
                    <button className="flex items-center gap-3 text-[14px] leading-[22px] font-medium text-sidebar-foreground hover:text-foreground flex-1 text-left group-data-[collapsible=icon]:justify-center">
                        {icon && <Icon name={icon} size={16} />}
                        <span className="group-data-[collapsible=icon]:hidden">{title}</span>
                        <ChevronDown
                            className={`h-4 w-4 transition-transform duration-200 group-data-[collapsible=icon]:hidden ${isOpen ? 'rotate-180' : ''
                                }`}
                        />
                    </button>
                </CollapsibleTrigger>

                {/* Header for Icon Mode: Just show the main icon? Or hidden? 
             Usually text headers are hidden in icon mode, and items are just listed 
             OR we show a separator. For now, we hide the header content in icon mode 
             and rely on specific CSS if needed. 
        */}

                {onAddClick && (
                    <button
                        onClick={onAddClick}
                        className="p-1 rounded-md hover:bg-muted-foreground/10 text-muted-foreground hover:text-foreground group-data-[collapsible=icon]:hidden transition-opacity opacity-100"
                    >
                        <Plus size={18} className={theme === 'dark' ? 'text-primary-200' : 'text-primary-600'} />
                    </button>
                )}
            </div>

            <CollapsibleContent className="space-y-1 group-data-[collapsible=icon]:hidden">
                {children}
            </CollapsibleContent>
        </Collapsible>
    );
}
